import AutoQueryController from "servicestack/auto-query/auto-query.controller";
import orderLabels from "emun.order/_labels";
//import CartItem from "emun.cart/cart-item.model";

export default class ChangeNoticeListController extends AutoQueryController {
  getQuery() {
    const $ctrl = this;
    $ctrl.labels = orderLabels;
    return {
      url: "QueryChangeNotices.json",
      fields: "*",
      orderBy: "-ChangedOn,OrderNumber",
      pageSize: 12,
      criteria: {
        orderNumber: $ctrl.orderId
      },
      views: {
        list: "th-list",
        cards: "th"
      },
      view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
      //view: "cards",
      filters: [
        { text: "ProductId", title: orderLabels.productId },
        { date: "OrderedOn", title: orderLabels.orderedOn },
        { date: "ChangedOn", title: "Change Date" }
      ],
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions: {
        OrderNumber: orderLabels.orderNumber,
        "-OrderNumber": orderLabels.orderNumber,
        "ProductId,OrderNumber": orderLabels.productId,
        "-ProductId,OrderNumber": orderLabels.productId,
        "OrderedOn,OrderNumber": orderLabels.orderedOn,
        "-OrderedOn,OrderNumber": orderLabels.orderedOn,
        "ChangedOn,OrderNumber": "Change Date: Newest",
        "-ChangedOn,OrderNumber": "Change Date: Oldest",
        "PreviousAvailableOn,OrderNumber": "Prev Avail Date: Newest",
        "-PreviousAvailableOn,OrderNumber": "Prev Avail Date: Oldest",
        "CurrentAvailbleOn,OrderNumber": "New Avail Date: Newest",
        "-CurrentAvailbleOn,OrderNumber": "New Avail Date: Oldest"
      }
    };
  }
}
